import { render, staticRenderFns } from "./messages-overlay.vue?vue&type=template&id=1025dc84&"
import script from "./messages-overlay.vue?vue&type=script&lang=js&"
export * from "./messages-overlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports